// 异样处理页面
import NoAuthority from '_src/pages/exception/NoAuthority'
import NoFound from '_src/pages/exception/NoFound'
import ServerError from '_src/pages/exception/ServerError'

// 路由路径
import Home from '_src/pages/home/home'
import Order from '_src/pages/order/order'
import OrderDetail from '_src/pages/order/detail'
import GoodList from '_src/pages/goods'
import GoodDetail from '_src/pages/goods/detail'
import GoodLog from '_src/pages/goods/log'
import Special from '_src/pages/appManager/special'

import Discount from '_src/pages/discount/list'
import Taste from '_src/pages/taste/taste'
import Salesman from '_src/pages/user/salesman/salesman'

import UserList from '_src/pages/user/userList'

import UserDetail from '_src/pages/user/detail'

import ReturnForm from '_src/pages/order/returnForm'
import ReturnDetail from '_src/pages/order/returnDetail'

import GoodType from '_src/pages/goods/goodsType'
import GoodsTips from '_src/pages/goods/goodsTip'
import StudentCertification from '_src/pages/studentCertification/studentCertification'
import HealthList from '_src/pages/trip/healthList'

import TravelList from '_src/pages/trip/travelList'
import TravelDetail from '_src/pages/trip/travelDetail'
import TravelNewList from '_src/pages/trip/travelNewList'

import EditTravel from '_src/pages/trip/editTravel'
import ReturnReason from '_src/pages/order/returnReason'

import Touristes from '../pages/order/touristes'

import Push from '_src/pages/app/push'

import Advert from '_src/pages/app/advert'

import Video from '_src/pages/goods/video'

import CouponSetting from '_src/pages/couponSetting/couponSetting'
// 财务管理开始
import Merchants from '_src/pages/finance/merchants/merchants'
import Withdrawal from '_src/pages/finance/withdrawal/withdrawal'
import RechargeLog from '_src/pages/finance/rechargeLog/rechargeLog'
import Recharge from '_src/pages/finance/recharge/recharge'
import Platform from '_src/pages/finance/platform/platform'
import SalesStatistic from '_src/pages/finance/salesStatistic/sale'
import BarRecord from '_src/pages/finance/barRecord/barRecord'
// 财务管理结束

import Versions from '_src/pages/app/versions'
import Setting from '_src/pages/app/setting/setting'

import MerchantList from '_src/pages/merchant/merchantList'

import MerchantType from '_src/pages/merchant/merchantType'

import AddMerchant from '_src/pages/merchant/addMerchant'

import MerchantDetail from '_src/pages/merchant/merchantDetail'

import WxPayMchConfigPage from '_src/pages/admin/wxPayMchConfig'
import WxMiniappPayBindPage from '_src/pages/admin/wxMiniappPayBind'

import SystemMessage from '_src/pages/app/message/message'
import PostMessage from '_src/pages/app/message/post'
import MessageDetail from '../pages/app/message/detail'
import TicketOrder from '_src/pages/app/order'

// 健康专线
import HealthOrderStatics from '../pages/order/healthOrder/statistics'
import HealthOrderForeign from '../pages/order/healthOrder/foreign'
//包车订单
import CharteredBus from '../pages/order/charteredBus/list'
import AddAdmin from '../pages/system/addAdmin'
import Feedback from '../pages/feedback/feedback'
//内部购
import InternalList from '../pages/user/internal/internalList'
//商城推荐
import FreshGoods from '../pages/recommended/freshGoods'
import Trucks from '../pages/recommended/trucks'
import FlashGood from '../pages/recommended/flashGood'
import AddFlash from '../pages/recommended/addFlash'
//每日签到-积分规则设置
import SignBoard from '_src/pages/signBoard/signBoard'
//每日签到-签到列表
import SignList from '_src/pages/signBoard/signList'

/* {
    *path: '/路径' 
    exact: exact
    unauthorized: true(不需要权限判断) || 默认false
    *component: 文件路径
    parentPaths : ['父路径'] // 此路由不由菜单进行跳转
} */
const routers = [
  {
    path: '/home',
    exact: true,
    component: Home,
  },
  {
    path: '/goods/list',
    exact: true,
    component: GoodList
  },
  {
    path: '/goods/log',
    exact: true,
    component: GoodLog
  },
  {
    path: '/goods/video',
    exact: true,
    component: Video
  },
  {
    path: '/certification/student',
    exact: true,
    component: StudentCertification
  },
  {
    path: '/order/list',
    exact: true,
    component: Order,
  },
  {
    path: '/appManager/specil',
    exact: true,
    component: Special,

  },
  {
    path: '/order/detail',
    component: OrderDetail,
  },
  {
    path: '/discount/list',
    exact: true,
    component: Discount,
  },
  {
    path: '/taste',
    exact: true,
    component: Taste,
  },
  {
    path: '/user/salesman',
    exact: true,
    component: Salesman,
  },
  {
    path: '/user/list',
    component: UserList
  },
  {
    path: '/user/detail',
    component: UserDetail,
    
  },
  {
    path: '/order/returnform',
    component: ReturnForm,
  },
  {
    path: '/order/returnDetail',
    component: ReturnDetail
  },
  {
    path: '/order/returnReason',
    component: ReturnReason
  },
  {
    path: '/goods/detail',
    exact: true,
    component: GoodDetail,
    unauthorized: true
  },
  
  {
    path: '/goods/type',
    exact: true,
    component: GoodType,
    unauthorized: true
  },
  {
    path: '/trip/healthList',
    exact: true,
    component: HealthList,
  },
  {
    path: '/trip/travelList',
    exact: true,
    component: TravelList,
  },
  {
    path: '/trip/travelNewList',
    exact: true,
    component: TravelNewList,
  },
  {
    path: '/trip/travelDetail',
    component: TravelDetail,
  },
  {
    path: '/trip/editTravel',
    exact: true,
    component: EditTravel,
    unauthorized: true,
  },
  {
    path: '/order/touristes',
    component: Touristes
  },
  {
    path: '/app/push',
    exact: true,
    component: Push,
  },
  {
    path: '/app/advert',
    exact: true,
    component: Advert,
  },
  {
    path: '/app/order',
    exact: true,
    component: TicketOrder,
  },
  {
    path: '/app/setting',
    exact: true,
    component: Setting,
  },
  
  {
    path: '/app/versions',
    exact: true,
    component: Versions,
  },
  {
    path: '/system/merchant/list',
    component: MerchantList
  },
  {
    path: '/system/merchant/types',
    component: MerchantType
  }, 
  {
    path: '/system/merchant/add',
    component: AddMerchant
  },
  {
    path: '/system/merchant/detail',
    component: MerchantDetail 
  },
  {
    path: '/app/message',
    exact: true,
    component: SystemMessage 
  },
  {
    path: '/app/message/post',
    exact: true,
    component: PostMessage 
  },
  {
    path: '/app/message/detail',
    component: MessageDetail, 
  },
  {
    path: '/couponSetting/couponSetting',
    component: CouponSetting
  },
  {
    path: '/order/healthOrder/statistics',
    component: HealthOrderStatics
  },
  {
    path: '/order/healthOrder/foreign',
    component: HealthOrderForeign
  },
  {
    path: '/order/charteredBus/list',
    component: CharteredBus
  },
  {
    path: '/admin/admin/list',
    component: AddAdmin
  },
  {
    path: '/admin/wxPayMch',
    exact: true,
    component: WxPayMchConfigPage
  },
  {
    path: '/admin/wxMiniappPayBind',
    exact: true,
    component: WxMiniappPayBindPage
  },
  
  // 财务统计开始
  {
    path: '/finance/platform',
    exact: true,
    component: Platform,
  },
  {
    path: '/finance/merchants',
    exact: true,
    component: Merchants,
  },
  {
    path: '/finance/salesStatistic',
    exact: true,
    component: SalesStatistic,
  },
  {
    path: '/finance/withdrawal',
    exact: true,
    component: Withdrawal,
  },
  {
    path: '/finance/recharge/log',
    exact: true,
    component: RechargeLog,
  },
  {
    path: '/finance/recharge',
    exact: true,
    component: Recharge,
  },
  {
    path: '/finance/barRecord',
    exact: true,
    component: BarRecord,
  },
  // 财务统计结束
  {
    path: '/app/feedback',
    exact: true,
    component: Feedback,
  },
  {
    path: '/user/internal',
    exact: true,
    component: InternalList,
  },
  //商城推荐
  {
    path: '/recommended/freshGoods',
    exact: true,
    component: FreshGoods,
  },
  {
    path: '/recommended/trucks',
    exact: true,
    component: Trucks,
  },
  {
    path: '/recommended/flashGood',
    exact: true,
    component: FlashGood,
  },
  {
    path: '/recommended/addFlash',
    exact: true,
    component: AddFlash,
  },
  {
    path: '/signBoard/signBoard',
    exact: true,
    component: SignBoard,
  },
  {
    path: '/signBoard/signList',
    exact: true,
    component: SignList,
  }
]

const initRoutes = [
  {
    path: '/403',
    exact: true,
    component: NoAuthority,
    unauthorized: true
  },
  {
    path: '/404',
    exact: true,
    component: NoFound,
    unauthorized: true
  },
  {
    path: '/500',
    exact: true,
    component: ServerError,
    unauthorized: true
  }
]

export default [...routers, ...initRoutes]